import { useState, useEffect } from "react";
import { getAccommodationDetials } from "api/apiService";
import Input from "components/Input";
import Button from "components/Button";
// Components
import RadioGroup from "../RadioGroup";
import SubUserPopup from "components/popups/SubUserPopup";
import { useSnackBar } from "../snackBar/SnackBarContext";
import Info from "../../assets/icons/ic_info.svg";
import {
  YES_NO_OPTIONS,
  CRUISE_OPTIONS,
  CATEGORY_OPTIONS,
} from "components/userForms/constants";

const AccommodationDetails = ({
  showPopup,
  formData,
  handleChange,
  formErrors,
  isInvited,
  setFormErrors,
  onKnownUserChange,
  onCategoryChange,
  allParticipantsData,
  inputRefs,
  inviteFormData,
  setInviteFormData,
}) => {
  const { showSnackbar } = useSnackBar();
  const [verify, setVerify] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [showParticipantQuestion, setShowParticipantQuestion] = useState(false);
  const [tripName, setTripName] = useState("");
  const userType = localStorage.getItem("userType");
  const [isReadOnly, setReadOnly] = useState(
    userType === "yes" || isInvited === "yes"
  );

  useEffect(() => {
    setReadOnly(userType === "yes" || isInvited === "yes");
  }, [isInvited, userType]);

  useEffect(() => {
    if (formData.hotelAccommodationId)
      handleChange({ target: { name: "userType", value: isInvited } });
    else if (formData.userType)
      handleChange({ target: { name: "userType", value: formData.userType } });
  }, [isInvited, formData.userType, formData.hotelAccommodationId]);

  useEffect(() => {
    if (!showPopup) return;
    if (formData.userType === "no") {
      setReadOnly(false);
      handleChange({ target: { name: "Category", value: "" } });
      handleChange({ target: { name: "Cruise", value: "" } });
      handleChange({ target: { name: "isKnownUser", value: "" } });
      handleChange({ target: { name: "tourOptions", value: [] } });
      handleChange({
        target: { name: "participantExists", value: "" },
      });
    } else if ((formData.userType = "yes")) {
      setReadOnly(true);
    }
  }, [formData.userType]);

  useEffect(() => {
    const trip = sessionStorage.getItem("tripName");
    setTripName(trip);
  }, []);

  const handleVerify = async () => {
    if (email === "") {
      setErrorMessage("Please enter email address");
      return;
    }
    try {
      setVerify(true);
      const res = await getAccommodationDetials(name, email, tripName);
      const isKnownUserRaw = res?.personalInfoDTO?.isKnownUser;
      const isKnownUser = isKnownUserRaw;
      const hotel = res?.hotelAccommodationDTOS?.[0]?.hotelType || "";
      const cruise = res?.cruiseAccommodationDTOS?.[0]?.cruiseType || "";
      const tourOptions = res?.tourPackageOptionDTOS || [];
      const participantExists = res?.participantExists || "";

      if (hotel === "Single") {
        setErrorMessage(
          "The primary traveler who invited you has chosen a single hotel accommodation. Please request them to update it to double."
        );
        setVerify(false);
        return;
      }

      localStorage.setItem("parentEmail", email);

      handleChange({ target: { name: "Category", value: hotel } });
      handleChange({ target: { name: "Cruise", value: cruise } });
      handleChange({ target: { name: "isKnownUser", value: isKnownUser } });
      handleChange({ target: { name: "tourOptions", value: tourOptions } });
      handleChange({
        target: { name: "participantExists", value: participantExists },
      });
      onKnownUserChange(isKnownUser);

      if (hotel === "Double") {
        setShowParticipantQuestion(true);
      } else {
        setShowParticipantQuestion(false);
      }

      // Also notify parent (Home) if needed
      onCategoryChange?.(hotel);
      handleChange({ target: { name: "isVerified", value: true } });
      showSnackbar("success", `Email verified!!`);
    } catch (error) {
      console.error("Error verifying subuser:", error);
      const errorList = error?.response?.data;

      if (Array.isArray(errorList) && errorList.length > 0) {
        const { errorCode, message } = errorList[0];
        if (errorCode === "400") {
          setErrorMessage(message);
        } else {
          setErrorMessage("Something went wrong. Please try again.");
        }
      } else {
        setErrorMessage("An unexpected error occurred.");
      }
    } finally {
      setVerify(false);
    }
  };

  const handleCategoryChange = (e) => {
    if (isReadOnly) return;
    const { name, value } = e.target;
    handleChange(e);
    handleChange({ target: { name: "isKnownUser", value: null } }); // reset isKnownUser

    if (name === "Category") {
      onCategoryChange?.(value); // notify parent
      if (value === "Double") {
        setShowParticipantQuestion(true);
      } else {
        setShowParticipantQuestion(false);
      }
    }
  };

  useEffect(() => {
    if (formData.Category === "Double") {
      setShowParticipantQuestion(true);
    } else {
      setShowParticipantQuestion(false);
    }
  }, [formData.Category]);

  return (
    <div className="block gap-4 w-full">
      <div ref={inputRefs.userType}>
        <RadioGroup
          label="Are you travelling with another person who has already registered for this tour and rooming?"
          name="userType"
          // options={["Yes", "No"]}
          options={YES_NO_OPTIONS}
          selectedValue={formData.isInvited || ""}
          onChange={(e) => {
            const value = e.target.value.toLowerCase();
            handleChange({ target: { name: "userType", value } });
          }}
          disabled={formData.isInvited === "yes" || formData.isInvited === "no"}
          error={formErrors.userType}
          required
        />

        {formData.userType === "yes" && !formData.hotelAccommodationId && (
          <>
            <div className="text-sm text-primary mb-3">
              Please enter the{" "}
              <span className="font-bold text-buttonColor"> NAME </span> and
              <span className="font-bold text-buttonColor">
                {" "}
                EMAIL ADDRESS{" "}
              </span>{" "}
              of the primary traveler so we can link your registration to their
              booking
            </div>
            <div className="md:flex items-start gap-2 pb-2">
              <div className="w-full">
                <Input
                  type="name"
                  name="name"
                  placeholder="Enter name"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  className="flex-grow"
                  marginBottom="mb-0"
                />
              </div>
              <div className="w-full md:pt-0 pt-4">
                <Input
                  type="email"
                  name="email"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setFormErrors((prev) => ({ ...prev, userType: "" }));
                    setErrorMessage("");
                  }}
                  className="flex-grow"
                  marginBottom="mb-0"
                />
                {errorMessage && (
                  <div className="flex gap-1 w-fit text-[10px] bg-red-100 text-red-600 rounded p-[2px] mt-2">
                    <img src={Info} alt="info" />
                    {errorMessage}
                  </div>
                )}
              </div>
              <div className="md:pt-0 pt-4">
                <Button
                  className="h-[37px] w-full text-white bg-buttonColor flex-shrink-0"
                  onClick={handleVerify}
                  text={verify ? "Verifying..." : "Verify"}
                />
              </div>
            </div>
          </>
        )}
      </div>

      {/* Cruise accommodation */}
      <div className="w-full">
        <h3 className="text-lg md:text-base font-semibold pb-4">
          Cruise accommodation:
        </h3>
        <div className="">
          <RadioGroup
            name="Cruise"
            options={CRUISE_OPTIONS}
            // options={[
            //   "Interior Stateroom (no window, occupancy up to 4 guests) - Standard",
            //   "Ocean View Stateroom (window, occupancy up to 4 guests)",
            //   "Balcony Stateroom (occupancy up to 2 guests) - Upgrade",
            // ]}
            selectedValue={formData.Cruise}
            onChange={handleChange}
            disabled={isReadOnly} // Disable input
            ref={inputRefs.Cruise}
          />
        </div>
      </div>

      {/* Hotel accommodation */}
      <div className="w-full">
        <h3 className="text-lg md:text-base font-semibold pb-4">
          Hotel accommodation:
        </h3>

        <RadioGroup
          label="Select Occupancy"
          name="Category"
          options={CATEGORY_OPTIONS}
          selectedValue={formData.Category}
          onChange={handleCategoryChange}
          disabled={
            isReadOnly ||
            (formData.Category === "Double" &&
              allParticipantsData.length === 1) ||
            (formData.participantExists === "yes" &&
              formData.participantCount === 0)
          }
          error={formErrors.Category}
          ref={inputRefs.Category}
          required
        />

        {/* Conditionally render new question */}
        {showParticipantQuestion && (
          <div className="mt-4">
            <RadioGroup
              label={
                <>
                  <p>
                    Will you be entering the registration information for the
                    second traveler?
                    <span className="text-red-500 pl-1">*</span>
                  </p>
                  <p className="text-[12px] text-yellow-800">
                    1. Yes – I will provide all the required information for the
                    second traveller.
                  </p>
                  <p className="text-[12px] text-yellow-800">
                    2. No – Please send an invitation to them to register in our
                    records or to link together.
                  </p>
                </>
              }
              name="isKnownUser"
              // options={
              //   allParticipantsData.length === 1 ? ["Yes"] : ["Yes", "No"]
              // }
              options={
                allParticipantsData.length === 1
                  ? YES_NO_OPTIONS.filter((opt) => opt.value === "yes")
                  : YES_NO_OPTIONS
              }
              selectedValue={formData.isKnownUser || ""}
              // selectedValue={
              //   formData.isKnownUser === "yes"
              //     ? "Yes"
              //     : formData.isKnownUser === "no"
              //     ? "No"
              //     : "" || ""
              // }
              onChange={(e) => {
                handleChange(e); // still update formData
                const value = e.target.value.toLowerCase();
                onKnownUserChange?.(value); // pass to parent
                if (value === "no") {
                  setIsPopupOpen(true); // open the popup
                }
              }}
              disabled={
                (formData.participantExists === "yes" &&
                  formData.participantCount === 0) ||
                isReadOnly
              } // :white_check_mark: disable input
              ref={inputRefs.isKnownUser}
              error={formErrors.isKnownUser}
            />
          </div>
        )}
      </div>

      {/* Popup */}
      {isPopupOpen && (
        <SubUserPopup
          isOpen={isPopupOpen}
          setIsPopupOpen={setIsPopupOpen}
          onClose={() => {
            handleChange({ target: { name: "isKnownUser", value: "yes" } });
            setIsPopupOpen(false);
            setInviteFormData("");
          }}
          mainFormData={formData}
          inviteFormData={inviteFormData}
          setInviteFormData={setInviteFormData}
        />
      )}
    </div>
  );
};

export default AccommodationDetails;
